import { useFeaturedListQuery } from '@/wabunka-src/common/features/Featured/composables/query/useGetFeaturedListQuery';
import type { MinimumFeaturedListViewModel } from '@/wabunka-src/common/features/Featured/models/minimunFeatured/minimumFeatured';
import { NAVIGATION_DESTINATIONS_LIMIT, NAVIGATION_THEMES_LIMIT } from '@/wabunka-src/constants/navigation';

import type { ComputedRef, InjectionKey } from 'vue';

export interface NavigationFeaturedData {
  destinations: ComputedRef<MinimumFeaturedListViewModel>;
  itineraries: ComputedRef<MinimumFeaturedListViewModel>;
  themes: ComputedRef<MinimumFeaturedListViewModel>;
}

export const NavigationFeaturedKey: InjectionKey<NavigationFeaturedData> = Symbol('NavigationFeaturedKey');

const emptyList = computed<MinimumFeaturedListViewModel>(() => []);

/**
 * ナビゲーション用 Featured データを inject する。
 * EnHeader / EnGlobalSidebar など、レイアウト配下のコンポーネントで使用する。
 */
export const useNavigationFeatured = (): NavigationFeaturedData => {
  return inject(NavigationFeaturedKey, {
    destinations: emptyList,
    itineraries: emptyList,
    themes: emptyList,
  });
};

/**
 * ナビゲーション用 Featured データを1回だけフェッチする。
 * 呼び出し元の <script setup> で provide と組み合わせて使用する。
 */
export const useFetchNavigationFeatured = async (): Promise<NavigationFeaturedData> => {
  const { destinationList, itineraryList, themeList } = await useFeaturedListQuery({
    types: ['destination', 'itinerary', 'theme'],
    destination: NAVIGATION_DESTINATIONS_LIMIT,
    theme: NAVIGATION_THEMES_LIMIT,
  });
  return { destinations: destinationList, itineraries: itineraryList, themes: themeList };
};
